import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseDataService } from '../../shared/services/base-data.service';
import { AppConfigService } from '../../shared/services/app-config.service';
import { LoaderService } from '../../shared/services/loader.service';
import { AlertsHandlerService } from '../../shared/services/alerts-handler.service';
import { PagedResponse } from '../../shared/models/paged-response.model';
import { Consol } from '../../shared/models/consol.model';
import { ConsolListFilterRequest } from '../../shared/models/consol-list-filter-request.model';
import { TrackerDetails } from '../models/tracker-details.model';
import { TrackAndTraceRequest } from '../../tracking/models/trackandtrace-request.model';
import { TrackingDetailsParameter } from '../../tracking/models/tracking-details-parameter.model';
import { TrackerShipmentJourney } from '../models/tracker-shipment-journey.model';
import { TrackAndTraceResponse } from '../../tracking/models/trackandtrace-response.model';
import { RouteDetails } from '../models/route-details.model';

@Injectable({
  providedIn: 'root'
})
export class TrackerDataService extends BaseDataService {
  constructor(
    protected httpClient: HttpClient,
    protected appConfigService: AppConfigService,
    protected loaderService: LoaderService,
    protected alertsHandlerService: AlertsHandlerService
  ) {
    super(httpClient, appConfigService, loaderService, alertsHandlerService);
  }

  public getList(filter: ConsolListFilterRequest): Observable<PagedResponse<Consol>> {
    let params = new HttpParams();

    Object.keys(filter).forEach(key => {
      params = params.append(key, filter[key]);
    });

    return this.get<PagedResponse<Consol>>('tracker/list', { params });
  }

  public getDetails(shipmentId: string): Observable<TrackerDetails> {
    return this.get<TrackerDetails>('tracker/' + shipmentId);
  }

  public getDetailsByParameter(filter: TrackingDetailsParameter): Observable<TrackerDetails> {
    // return this.get<TrackingDetails>('tracking/' + shipmentId);
    const params = new HttpParams()
      .set('ShipmentCode', filter.ShipmentCode)
      .set('HouseBillNumber', filter.HouseBillNumber)
      .set('MasterBillNumber', filter.MasterBillNumber);
    return this.get<TrackerDetails>('tracker/trackingDetails', { params });
  }

  public addTrackAndTrace(request: TrackAndTraceRequest): Observable<PagedResponse<TrackAndTraceResponse>> {
    const params = new HttpParams()
      .set('MBLNumber', request.MBLNumber)
      .set('StaffUserId', request.StaffUserId.toString())
      .set('CreatedDate', request.CreatedDate.toDateString());
    return this.get<PagedResponse<TrackAndTraceResponse>>('Tracker/createTrackAndTrace/', { params });
  }

  public getShipmentJourneyList(shipmentId: string): Observable<PagedResponse<TrackerShipmentJourney>> {
    return this.get<PagedResponse<TrackerShipmentJourney>>('tracker/' + shipmentId + '/journey');
  }

  public getMapURL(route: RouteDetails, shipmentId: string): Observable<RouteDetails> {
    return this.post<RouteDetails>('tracker/' + shipmentId + '/getMapURL', route);
  }

  public getShipmentRouteDetails(shipmentId: string): Observable<PagedResponse<RouteDetails>> {
    return this.get<PagedResponse<RouteDetails>>('tracker/' + shipmentId + '/routingDetails');
  }
}
